<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

/*
 * (derived: the canonical design-system project has no Kbd spec to reconcile
 * against.) Kept close to the shadcn-vue default — `h-5`/`w-fit min-w-5` so a
 * one- or multi-character key reads the same — but bordered rather than a flat
 * `bg-muted` fill, matching the chip this app already used inline for search
 * shortcuts before this was pulled out into @ds.
 */
const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <kbd
    :class="cn(
      'inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1',
      'rounded-ds-sm border border-border bg-background px-1.5',
      'font-ds text-xs font-bold text-muted-foreground select-none pointer-events-none',
      '[&_svg:not([class*=\'size-\'])]:size-3',
      props.class,
    )"
  >
    <slot />
  </kbd>
</template>
